import { notificationsSelector, useShowMessage } from '@map/state/notifications';
import { parseAjaxError } from '@shared/setupAxios';
import type { AxiosError } from 'axios';
import { useSelector } from 'react-redux';

export { useShowMessage } from '@map/state/notifications';

export const useNotifications = () => useSelector(notificationsSelector);

export const useShowAjaxError = () => {
  const showMessage = useShowMessage();
  return (error: AxiosError) => {
    const messages = parseAjaxError(error);
    messages.forEach((message) => {
      showMessage({ type: 'error', ...message });
    });
  };
};
